export default __webpack_public_path__ + "static/media/whatsapp.3c94f5ce.svg";